(function (exports) {
  exports.Message = {
    Status: 'STATUS'
  }
}(typeof exports === 'undefined' ? this.swConst = {} : exports))
